const StatusActionTypes = {
    TOGGLE_ACCORDION_CHANGE: 'TOGGLE_ACCORDION_CHANGE'
}

export default StatusActionTypes;